export default ({ backgroundColor = null, textColor = null, ...rest }) => ({
  backgroundColor,
  textColor,
  ...rest,
});
